export const DIRECT_INVOICE = {
  BASE_PATH: "/direct-sale-order/invoice/",
  MAKE_PAYMENT_RECEIVE_PATH(id: string | number) {
    return this.BASE_PATH + `${id}` + "/edit/make-payment-receive";
  },
  ADD_PATH() {
    return this.BASE_PATH + "add";
  },
  ADD_BUTTON_TITLE: "Add New Direct Sale Order Invoice",
  LIST_PAGE_TITLE: "Direct Sale Order List",
  EDIT_PAGE_TITLE: "Edit Direct Sale Order",
  GET_ALL: "direct-sale-order/invoice",
  GET_ONE: "direct-sale-order/invoice/edit/",
  CREATE: "direct-sale-order/invoice",
  UPDATE: "direct-sale-order/invoice/update/",
  DELETE: "direct-sale-order/invoice/delete/",
  ADD_NEW_TITLE: "Add New Direct Sale Order Invoice",
  GET_ONE_SALE_ORDER_FOR_PRINT: "direct-sale-order/invoice/print/",
};
